import Vue from 'vue'
Vue.mixin({
  methods: {
    _getBaseImageUrl(image) {
      if (!image || typeof image !== 'object') return null
      if (!image.is_image) return image.permalink

      let pathPart = image.url.split(process.env.backendUrl)[1]

      if (!pathPart && process.env.assetUrl) {
        pathPart = image.url.split(process.env.assetUrl)[1]
      }

      return `${process.env.backendUrl}/img/${pathPart}`.replace(
        /([^:]\/)\/+/g,
        '$1'
      )
    },
    imageFocusUrl(image, width = 400, height = 400) {
      const baseUrl = this._getBaseImageUrl(image)

      if (!baseUrl) return null

      return (
        `${baseUrl}?w=${width}&h=${height}` +
        (image.focus ? `&fit=crop-${image.focus}` : '')
      )
    },
    imageUrl(image, width = 3000) {
      const baseUrl = this._getBaseImageUrl(image)

      if (!baseUrl) return null

      return `${baseUrl}?w=${width}&fit=max`
    },
    linebreaksForHtml(value) {
      if (!value || typeof value !== 'string') return value

      return value.replace(/\n/g, '<br/>')
    },
    wrapLinesInParagraphs(value) {
      if (!value || typeof value !== 'string') return value

      return value
        .split(/\r?\n+/)
        .map((line) => line.trim())
        .filter((line) => line.length > 0)
        .map((line) => `<p class="mb-4">${line}</p>`)
        .join('')
    },
    getEventCalendarDatePart(date) {
      if (!date) return null

      if (date.includes('T')) {
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Zurich',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).formatToParts(new Date(date))

        const year = parts.find((part) => part.type === 'year')?.value
        const month = parts.find((part) => part.type === 'month')?.value
        const day = parts.find((part) => part.type === 'day')?.value

        return year && month && day ? `${year}-${month}-${day}` : null
      }

      if (date.includes('.')) {
        const [day, month, year] = date.split('.')

        return year && month && day
          ? `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
          : null
      }

      return date.split(' ')[0]
    },
    getEventCalendarToday() {
      return this.getEventCalendarDatePart(new Date().toISOString())
    },
    formatEventCalendarDate(date) {
      const [year, month, day] = this.getEventCalendarDatePart(date).split('-')

      return `${day}.${month}.${year}`
    },
    formatEventCalendarDateWithoutYear(date) {
      const [, month, day] = this.getEventCalendarDatePart(date).split('-')

      return `${day}.${month}.`
    },
    formatEventCalendarWeekday(date) {
      const [year, month, day] = this.getEventCalendarDatePart(date)
        .split('-')
        .map(Number)
      const weekday = new Intl.DateTimeFormat('de-CH', {
        weekday: 'short',
        timeZone: 'UTC',
      }).format(new Date(Date.UTC(year, month - 1, day)))

      return weekday.endsWith('.') ? weekday : `${weekday}.`
    },
    formatEventCalendarDateRange(dateRange) {
      const start = dateRange?.start
      const end = dateRange?.end

      if (!start || !end) {
        return {
          start: '',
          end: '',
        }
      }

      if (
        this.getEventCalendarDatePart(start) ===
        this.getEventCalendarDatePart(end)
      ) {
        return {
          start: this.formatEventCalendarWeekday(start),
          end: this.formatEventCalendarDate(end),
        }
      }

      return {
        start: this.formatEventCalendarDateWithoutYear(start),
        end: `bis ${this.formatEventCalendarDate(end)}`,
      }
    },
  },
})
